module.exports = __webpack_public_path__ + "821bbaa634398399feab23e2929265c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/team/Leadership_Curtis_0.jpg
// module id = 373
// module chunks = 0